'use strict';

import Async from 'async';
import _ from 'lodash';

export default class AccountingUnitsUploadController {
  /*@ngInject*/
  constructor($http, $q, $cookies, $timeout, $uibModalInstance) {
    this.$http = $http;
    this.$q = $q;
    this.$cookies = $cookies;
    this.$timeout = $timeout;
    this.$uibModalInstance = $uibModalInstance;

    this.fileInputField;
    this.isUploading = false;

    this.data = {
      selectedFiles: [],
      excelFileOnServer: '',
      excel: null,
      excelSelectedTabs: [],
      excelSelectedTabIdx: 0,
      excelSelectedTabData: null
    };
    this.excelColumns = [];

    this.targetSheetName = 'Accounting Unit';
    this.fieldOptions = [
      {name: 'HROrganizationUnit', value: 'hrOrganizationUnit', alias: []},
      {name: 'ShortDescription', value: 'shortDescription'},
      {name: 'Description', value: 'description', alias: []},
      {name: 'ParentUnitShortDescription', value: 'parentUnitShortDescription', alias: []},
      {name: 'MVS or BSC?', value: 'mvsOrBsc', alias: []}
    ];

    this.form = {
      mappedFields: {}
    };
    this.invalidTabMsg = false;
    this.isImporting = false;
    this.importProgress = {
      current: 0,
      total: 0,
    };
  }

  sizeOf(obj) {
    return _.size(obj);
  }

  uploadFile() {
    let self = this;
    this.isUploading = true;
    this.$http({
        method: 'POST',
        url: '/api/types/companies/accountingUnits/upload?access_token=' + this.$cookies.get('token'),
        headers: {
          'Content-Type': undefined
        },
        data: {
          file: this.fileInputField
        },
        transformRequest: function(data, headersGetter) {
          let formData = new FormData();
          angular.forEach(data, function (value, key) {
            formData.append(key, value);
          });
          return formData;
        }
    })
    .then(function(response) {
      self.data.excelFileOnServer = response.data;
      self.parseFile(response.data);
      self.isUploading = false;
    }, function(error) {
      self.isUploading = false;
    });
  }

  parseFile(filename) {
    let self = this;
    this.$http.post('/api/types/companies/accountingUnits/parse',  {
      filename: filename
    }).then(function(response) {
      self.data.excel = response.data;
      if(_.size(self.data.excel.sheets)) {
        
        let matchSheetIdx;
        // create tabs
        angular.forEach(self.data.excel.sheets, function(sheet, idx) {
          self.data.excelSelectedTabs.push(sheet.name);
          if(sheet.name === self.targetSheetName) {
            matchSheetIdx = idx;
          }
        });
        if(angular.isDefined(matchSheetIdx)) {
          self.data.excelSelectedTabIdx = matchSheetIdx;
        }
        self.selectTab(self.data.excelSelectedTabIdx);
      } else {
        self.data.resultMsg = 'Invalid excel.';
      }
    }, function(error) {

    });
  }

  colName(n) {
    var ordA = 'a'.charCodeAt(0);
    var ordZ = 'z'.charCodeAt(0);
    var len = ordZ - ordA + 1;
    var s = "";
    while(n >= 0) {
      s = String.fromCharCode(n % len + ordA) + s;
      n = Math.floor(n / len) - 1;
    }
    return s.toUpperCase();
  }

  createEmptyArray(nth) {
    let _array = [];
    let i = 0;
    for(i=0; i<nth; i++) {
      _array.push(this.colName(i));
    }
    this.excelColumns = _array;
  }

  guessColumnField() {
    let self = this;
    let match;
    let idx;

    angular.forEach(this.data.excelSelectedTabData.rows[1], function(col, k) {
      match = _.find(self.fieldOptions, function(o) {
        return o.name.toLowerCase() === col.v.toLowerCase();
      });
      if(match) {
        idx = _.findKey(self.excelColumns, function(o) {
          return o === k;
        });
        if(idx) {
          self.form.mappedFields[idx] = match.value;
        }
      } else {
        match = _.find(self.fieldOptions, function(o) {
          if(o.alias && o.alias.length) {
            return o.alias.indexOf(col.v) !== -1;
          }
          return false;
        });
        if(match) {
          idx = _.findKey(self.excelColumns, function(o) {
            return o === k;
          });
          if(idx) {
            self.form.mappedFields[idx] = match.value;
          }
        }
      }
    });
  }

  selectTab(idx) {
    let self = this;
    this.data.excelSelectedTabData = null;
    this.invalidTabMsg = false;
    this.$timeout(function() {
      let i = 0;
      let o;
      for(o in self.data.excel.sheets) {
        if(i === idx) {
          self.data.excelSelectedTabData = self.data.excel.sheets[o];
          self.createEmptyArray(self.data.excelSelectedTabData.overallMaxColumnCount);
          break;
        } else {
          i++;
        }
      }
      self.data.excelSelectedTabIdx = idx;
      // if(_.size(self.data.excelSelectedTabData.rows[1]) !== self.fieldOptions.length) {
      //   self.invalidTabMsg = true;
      // }
    });
  }

  rendered() {
    this.guessColumnField();
  }

  submitForm(form) {
    if(form.$valid) {
      if(this.data.excel) {
        let self = this;
        this.isImporting = true;
        let payload = {
          filename: self.data.excelFileOnServer,
          tabIdx: self.data.excelSelectedTabIdx,
          mappedFields: this.form.mappedFields,
          excelColumns: self.excelColumns
        };
        console.log(payload);
        // return;
        this.$http.post('/api/types/companies/accountingUnits/import', payload).then(function(response) {
          self.$timeout(function() {
            self.$uibModalInstance.close();
          }, 5000);
        }, function(error) {

        });
      }
    }
  };

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/accountingUnits.upload.controller.js